import React, {useEffect, useRef, useState} from "react";
import {createRoot, Root} from "react-dom/client";
import Coordinates from "@app/model/hotel/Coordinates";
import {Wrapper} from "@googlemaps/react-wrapper";
import Property from "@app/site/registration/fragment/state/Property";
import SearchHotelResult from "@app/component/form/input/autocomplete/SearchHotelResult";
import usePropertiesState from "@app/site/registration/fragment/state/PropertiesState";
// import Geocoder = google.maps.Geocoder;


const API_KEY = "AIzaSyA95q2kWspsMWiCg8MXAuxRofWx0ViCTGs"

const greece = {
    "lat": 39.074208,
    "lng": 21.824312
}
const AddPropertiesGoogleMapFragment: React.FunctionComponent<{ property: Property | undefined }> = ({property}) => {
    const [_property, setProperty] = useState<Property | undefined>();
    const [options, setOptions] = useState<google.maps.MapOptions>();
    const [centerCoordinates, setCenterCoordinates] = useState<Coordinates>(greece);
    const [zoom, setZoom] = useState<number>(6);

    useEffect(() => {
        setProperty(property)
    }, [property]);

    useEffect(() => {
        setOptions({
            zoom: 6,
            mapId: "71650332a8c41b4f",
            streetViewControl: false,
            mapTypeControl: false,
            scaleControl: false,
            zoomControl: true,
            // gestureHandling: "none",
            fullscreenControl: false,
            zoomControlOptions: {
                position: 9.0
            }
        })
    }, []);

    useEffect(() => {
        if (_property && _property.hotel) {
            setCenterCoordinates(_property.hotel.coordinates!);
            setZoom(12)
        } else {
            setCenterCoordinates(greece)
            setZoom(6)
        }
    }, [_property]);


    return <Wrapper apiKey={API_KEY} libraries={["marker"]} version="beta">
        {!!options && <HotelsMap options={options} property={_property} coordinates={centerCoordinates} zoom={zoom}/>}
    </Wrapper>
}

const centerMapButton = (map: google.maps.Map, coordinates: Coordinates) => {
    return <button className="btn btn-white text-gray-700 font-semibold mt-2 ml-2 rounded-sm" onClick={() => {
        map.setCenter(coordinates);
        map.setZoom(6)
    }}>Reset Map</button>
}

const HotelsMap: React.FunctionComponent<{
    options: any,
    property: Property | undefined,
    coordinates: Coordinates,
    zoom: number
}> = ({
          options,
          coordinates,
          property,
          zoom = 6
      }) => {
    const [map, setMap] = useState<google.maps.Map>();
    const ref = useRef<HTMLDivElement>(null);
    const rootRef = useRef<Root>(null);
    const state = usePropertiesState()

    useEffect(() => {
        const map = new window.google.maps.Map(ref.current!, options);
        const container = document.createElement("div");
        // @ts-ignore
        rootRef.current = createRoot(container);
        // rootRef.current!.render(centerMapButton(map, coordinates))

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(container);

        setMap(map);
    }, []);

    useEffect(() => {
        if (!!coordinates && !!map) {
            map.setCenter(coordinates);
            map.setZoom(zoom)
        }
    }, [map, coordinates])

    useEffect(() => {
        if (!!property && !!map) {
            state.removeMarkers();
            const markers = [];
            if (property.hotel) markers.push(addMarker(property.hotel, map, true))
            if (property.competitors) {
                property.competitors.filter(c => !!c).forEach(c => markers.push(addMarker(c!, map)))
            }
            state.setMarkers(markers);
        } else if(!!map && !property) {
            state.removeMarkers();
        }
    }, [map, property]);


    const addMarker = (hotel: SearchHotelResult, map: google.maps.Map, isMain: boolean = false) => {
        return new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: hotel.coordinates,
            title: hotel.name,
            content: isMain ? new google.maps.marker.PinElement({
                scale: 1,
                borderColor: '#B91C1C',
                background: '#DC2626',
                glyphColor: '#FCA5A5'
            }).element : new google.maps.marker.PinElement({
                scale: 1,
                borderColor: '#1D4ED8',
                background: '#2563EB',
                glyphColor: '#93C5FD'
            }).element
        })
    }

    return <>
        <div className="absolute inset-0 h-full w-full" ref={ref} id={"map"}></div>
    </>
}


export default AddPropertiesGoogleMapFragment;